import React from "react";
import PropTypes from "prop-types";
import { animations } from "react-animation";
import "./DownloadSection.css";
import IconoDownload from "./../../assets/img/download/Download Icon.png";

const ROOT = process.env.REACT_APP_CMS_STATIC;

DownloadSection.propTypes = {
  title: PropTypes.string,
  downloadLinks: PropTypes.array,
};

function DownloadSection({ title = "Descargas", downloadLinks, ...props }) {
  function filename(url) {
    var rutaAbsoluta = url;
    var posicionUltimaBarra = rutaAbsoluta.lastIndexOf("/");
    var rutaRelativa = rutaAbsoluta.substring(
      posicionUltimaBarra + "/".length,
      rutaAbsoluta.length
    );
    return rutaRelativa;
  }

  return (
    <div style={{ animation: animations.fadeIn }}>
      {downloadLinks && (
        <div>
          <div className="downloadlinksTitle">{title}</div>
          <ul>
            {downloadLinks.map((lnk, index) => (
              <li key={index} className="d-flex align-items-center mt-3 mb-3">
                <div>
                  <img
                    src={lnk.image ? lnk.image : IconoDownload}
                    width={40}
                    height={40}
                    alt=""
                  />
                </div>
                <div className="ms-2">
                  <a
                    className="downloadlinksText"
                    href={lnk.archivo ? ROOT + lnk.archivo.urls[0] : ROOT + lnk}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {lnk?.tituloEnlace
                      ? lnk?.tituloEnlace
                      : filename(ROOT + lnk)}
                  </a>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DownloadSection;
